// The opening book: what the server has, and which level its numbers are for.

import { errorText, getJson, isSignedOut } from "./api.ts";
import { prefs } from "./prefs.ts";

export interface BookInfo {
  available: boolean;
  info: { built_at?: number; positions?: number; lichess_games?: number; masters_games?: number; evaluated?: number } | null;
  band: string | null;
  rating: number | null;
  error?: string;
}

let asked: Promise<BookInfo> | null = null;

/** The book's build record and the account's own level, asked once a
 *  session. Until the book exists this answers `available: false`, and every
 *  screen that needs the book says so. */
export function bookInfo(): Promise<BookInfo> {
  if (!asked) {
    asked = getJson<BookInfo>("/api/openings/book").catch((err) => {
      asked = null;
      if (isSignedOut(err)) throw err;
      return { available: false, info: null, band: null, rating: null, error: errorText(err) };
    });
  }
  return asked;
}

/** The band the book's numbers are for: the one chosen in Settings, else the
 *  one the server reads off your games. */
export async function currentBand(): Promise<string> {
  if (prefs.band) return prefs.band;
  return (await bookInfo()).band || "";
}

/** Only a chosen band is sent — the server falls back to your own rating. */
export const chosenBand = (): string => prefs.band || "";
